import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    display: flex;
`;

export const BackArrowIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const Title = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    color: #040222;
    margin: 16px 0;
`;

export const InputWrapper = styled.div`
    display: flex;
    margin: 16px 0;
`;

export const AddButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 32px;
`;
